import { PROGRAM } from "@bussola-viagens/constants"
import { UpdateProgramCostSchema } from "@bussola-viagens/validations"
import { cost as databaseCost } from "@bussola-viagens/database"
import { useFormik } from "formik"
import { useCallback, useEffect, useMemo, useState } from "react"
import { Grid, Paper, LoaderContainer, Loader, PriceSetting } from "../../../components"
import { useAPI } from "../../../hooks"
import { CostForm } from "./CostForm"
import { enqueueSnackbar } from "notistack"

const defaultValues = {
    prices: [] as PriceSetting[],
}

export const Programs = () => {
    const [setup, setSetup] = useState(false)
    const [cost] = useAPI(`/cost`)

    const [updatedGroupConfiguration, updateProgramCostPrices] = useAPI({
        method: 'PUT'
    }, {
        manual: true
    })

    const updateCostConf = useCallback(async (values: { [key: string]: any }, company: PROGRAM) => {
        const { status } = await updateProgramCostPrices({
            url: `/cost/${company}`,
            data: values
        })

        if (status <= 299) {
            enqueueSnackbar('Custos atualizados com sucesso!', { variant: 'success' })
        }
    }, [updateProgramCostPrices])

    const iberiaFormik = useFormik({
        initialValues: defaultValues,
        validationSchema: UpdateProgramCostSchema,
        onSubmit: async (values, formHelpers) => {
            updateCostConf(values, PROGRAM.IBERIA_PLUS)
            formHelpers.resetForm({values})
        }
    })

    const smilesBRFormik = useFormik({
        initialValues: defaultValues,
        validationSchema: UpdateProgramCostSchema,
        onSubmit: async (values, formHelpers) => {
            updateCostConf(values, PROGRAM.SMILES_BR)
            formHelpers.resetForm({values})
        }
    })

    const tapFormik = useFormik({
        initialValues: defaultValues,
        validationSchema: UpdateProgramCostSchema,
        onSubmit: async (values, formHelpers) => {
            updateCostConf(values, PROGRAM.TAP)
            formHelpers.resetForm({values})
        }
    })

    const smilesARFormik = useFormik({
        initialValues: defaultValues,
        validationSchema: UpdateProgramCostSchema,
        onSubmit: async (values, formHelpers) => {
            updateCostConf(values, PROGRAM.SMILES_AR)
            formHelpers.resetForm({values})
        }
    })

    const azulInterlineFormik = useFormik({
        initialValues: defaultValues,
        validationSchema: UpdateProgramCostSchema,
        onSubmit: async (values, formHelpers) => {
            updateCostConf(values, PROGRAM.AZUL_INTERLINE)
            formHelpers.resetForm({values})
        }
    })

    const azulViagensFormik = useFormik({
        initialValues: defaultValues,
        validationSchema: UpdateProgramCostSchema,
        onSubmit: async (values, formHelpers) => {
            updateCostConf(values, PROGRAM.AZUL_VIAGENS)
            formHelpers.resetForm({values})
        }
    })

    const tudoAzulFormik = useFormik({
        initialValues: defaultValues,
        validationSchema: UpdateProgramCostSchema,
        onSubmit: async (values, formHelpers) => {
            updateCostConf(values, PROGRAM.TUDO_AZUL)
            formHelpers.resetForm({values})
        }
    })

    const aadvantageFormik = useFormik({
        initialValues: defaultValues,
        validationSchema: UpdateProgramCostSchema,
        onSubmit: async (values, formHelpers) => {
            updateCostConf(values, PROGRAM.AADVANTAGE)
            formHelpers.resetForm({values})
        }
    })

    const latamARFormik = useFormik({
        initialValues: defaultValues,
        validationSchema: UpdateProgramCostSchema,
        onSubmit: async (values, formHelpers) => {
            updateCostConf(values, PROGRAM.LATAMPASS_AR)
            formHelpers.resetForm({values})
        }
    })

    const latamBRFormik = useFormik({
        initialValues: defaultValues,
        validationSchema: UpdateProgramCostSchema,
        onSubmit: async (values, formHelpers) => {
            updateCostConf(values, PROGRAM.LATAMPASS_BR)
            formHelpers.resetForm({values})
        }
    })

    const airEuropaFormik = useFormik({
        initialValues: defaultValues,
        validationSchema: UpdateProgramCostSchema,
        onSubmit: async (values, formHelpers) => {
            updateCostConf(values, PROGRAM.AIR_EUROPA)
            formHelpers.resetForm({values})
        }
    })

    const lifeMilesFormik = useFormik({
        initialValues: defaultValues,
        validationSchema: UpdateProgramCostSchema,
        onSubmit: async (values, formHelpers) => {
            updateCostConf(values, PROGRAM.LIFEMILES)
            formHelpers.resetForm({values})
        }
    })

    const flyingBlueFormik = useFormik({
        initialValues: defaultValues,
        validationSchema: UpdateProgramCostSchema,
        onSubmit: async (values, formHelpers) => {
            updateCostConf(values, PROGRAM.FLYING_BLUE)
            formHelpers.resetForm({values})
        }
    })

    const connectMileFormik = useFormik({
        initialValues: defaultValues,
        validationSchema: UpdateProgramCostSchema,
        onSubmit: async (values, formHelpers) => {
            updateCostConf(values, PROGRAM.CONNECT_MILES)
            formHelpers.resetForm({values})
        }
    })

    const aeroplanFormik = useFormik({
        initialValues: defaultValues,
        validationSchema: UpdateProgramCostSchema,
        onSubmit: async (values, formHelpers) => {
            updateCostConf(values, PROGRAM.AEROPLAN)
            formHelpers.resetForm({values})
        }
    })

    const tudoAzulV2Formik = useFormik({
        initialValues: defaultValues,
        validationSchema: UpdateProgramCostSchema,
        onSubmit: async (values, formHelpers) => {
            updateCostConf(values, PROGRAM.TUDO_AZUL_V2)
            formHelpers.resetForm({values})
        }
    })

    const forms = useMemo(() => [
        { program: PROGRAM.SMILES_BR, label: 'Smiles BR', formik: smilesBRFormik },
        { program: PROGRAM.SMILES_AR, label: 'Smiles AR', formik: smilesARFormik },
        { program: PROGRAM.LATAMPASS_BR, label: 'Latam BR', formik: latamBRFormik },
        { program: PROGRAM.LATAMPASS_AR, label: 'Latam AR', formik: latamARFormik },
        { program: PROGRAM.AADVANTAGE, label: 'AAdvantage', formik: aadvantageFormik },
        { program: PROGRAM.TUDO_AZUL, label: 'Tudo Azul', formik: tudoAzulFormik },
        { program: PROGRAM.TUDO_AZUL_V2, label: 'Tudo Azul (Menos Milhas)', formik: tudoAzulV2Formik },
        { program: PROGRAM.AZUL_INTERLINE, label: 'Azul Interline', formik: azulInterlineFormik },
        { program: PROGRAM.AZUL_VIAGENS, label: 'Azul Viagens', formik: azulViagensFormik },
        { program: PROGRAM.IBERIA_PLUS, label: 'Iberia Plus', formik: iberiaFormik },
        { program: PROGRAM.TAP, label: 'TAP', formik: tapFormik },
        { program: PROGRAM.AIR_EUROPA, label: 'Air Europa SUMA', formik: airEuropaFormik },
        { program: PROGRAM.LIFEMILES, label: 'Lifemiles', formik: lifeMilesFormik },
        { program: PROGRAM.FLYING_BLUE, label: 'Flying Blue', formik: flyingBlueFormik },
        { program: PROGRAM.CONNECT_MILES, label: 'Connect Miles', formik: connectMileFormik },
        { program: PROGRAM.AEROPLAN, label: 'Aeroplan', formik: aeroplanFormik },
    ], [aadvantageFormik, aeroplanFormik, airEuropaFormik, azulInterlineFormik, azulViagensFormik, connectMileFormik, flyingBlueFormik, iberiaFormik, latamARFormik, latamBRFormik, lifeMilesFormik, smilesARFormik, smilesBRFormik, tapFormik, tudoAzulFormik, tudoAzulV2Formik])

    useEffect(() => {
        if (cost.data && !setup) { 
            setSetup(true)   
            forms.forEach(form => {
                const programCost = cost.data.find((item: databaseCost) => item.program === form.program)
                
                form.formik.resetForm({
                    values: {
                        prices: programCost.prices || []
                    },
                })
            })
        }
    }, [cost.data, forms, setup])

    if (cost.loading || !setup) {
        return (
            <LoaderContainer>
                <Loader />
            </LoaderContainer>
        )
    }

    return (
        <Grid container spacing={1}>
            {
                forms.map((form, index) => {
                    return (
                        <Grid item xs={12} key={index.toString()}>
                            <Paper>
                                <CostForm 
                                    label={form.label} 
                                    formik={form.formik} 
                                    program={form.program} 
                                />
                            </Paper>
                        </Grid>
                    )
                })
            }
        </Grid>
    )
}